import React, { useRef, useState } from 'react';

import Button, { LoadingButton } from '@atlaskit/button';
import Modal, { ModalTransition } from '@atlaskit/modal-dialog';

import { ModalBody, ModalFooter, ModalHeader } from '@qality/common-components';
import { TestTypeProvider } from '@qality/common-pages/src/TestTypesPage/TestTypesProvider';

import AddTestCaseToCycleForm from '../AddTestCaseToCycleForm';
import { useTestCasesInCycleList } from '../testCasesInCycleList/TestCaseInCycleListProvider';

export default function AddTestCasesToCycleModal(): JSX.Element {
  const [selectedIssuesIds, setSelectedIssuesIds] = useState<Array<string>>([]);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const addTestCaseToCycleModalRef = useRef(null);

  const [isLoadingDialog, setIsLoadingDialog] = useState<boolean>(false);
  const { testCaseActions, testCycle } = useTestCasesInCycleList();
  const openDialog = () => {
    setIsOpen(true);
  };

  const closeDialog = () => {
    setIsOpen(false);
    setSelectedIssuesIds([]);
    setIsLoadingDialog(false);
  };

  const onAddTestCase = async () => {
    if (selectedIssuesIds.length) {
      setIsLoadingDialog(true);
      await testCaseActions.addTestCases(selectedIssuesIds);
      closeDialog();

      setIsLoadingDialog(false);
    } else {
      addTestCaseToCycleModalRef?.current.showIsRequiredError();
    }
  };

  const selectedIssueChanged = (issuesIds: Array<string>) => {
    setSelectedIssuesIds(issuesIds);
  };

  return (
    <div>
      {testCycle.canEdit && !testCycle.isClosed && (
        <Button appearance='primary' onClick={openDialog}>
          + Add Test Cases to Test Cycle
        </Button>
      )}
      <ModalTransition>
        {isOpen && (
          <Modal
            onClose={closeDialog}
            shouldCloseOnOverlayClick={false}
            shouldCloseOnEscapePress={true}
            shouldScrollInViewport
          >
            <ModalHeader title='Add Test Cases to Test Cycle' />
            <ModalBody>
              <TestTypeProvider>
                <AddTestCaseToCycleForm
                  ref={addTestCaseToCycleModalRef}
                  selectedIssueChanged={selectedIssueChanged}
                  project={testCycle.project}
                />
              </TestTypeProvider>
            </ModalBody>
            <ModalFooter>
              <Button appearance='subtle' onClick={closeDialog}>
                Cancel
              </Button>
              <LoadingButton
                isLoading={isLoadingDialog}
                appearance='primary'
                onClick={onAddTestCase}
              >
                Add
              </LoadingButton>
            </ModalFooter>
          </Modal>
        )}
      </ModalTransition>
    </div>
  );
}
